import { http } from '../http'

export interface DataScreenEfficiency {
  dailyAverage?: number
  weeklyAverage?: number
  monthlyAverage?: number
  yearlyAverage?: number
}

export interface DataScreenOverview {
  totalSales?: number
  previousTotalSales?: number
  totalSalesComparisonRate?: number
  averageOrderAmount?: number
  previousAverageOrderAmount?: number
  averageOrderAmountComparisonRate?: number
  salesQuantity?: number
  previousSalesQuantity?: number
  salesQuantityComparisonRate?: number
  salesEfficiency?: DataScreenEfficiency
}

export interface DataScreenOverviewParams {
  startDate: string
  endDate: string
}

export interface DataScreenRanking {
  storeId?: number
  storeName?: string
  amount?: number
}

export interface DataScreenRankings {
  salesTopStores?: DataScreenRanking[]
  purchaseTopStores?: DataScreenRanking[]
}

export interface DataScreenRankingsParams extends DataScreenOverviewParams {
  topN: number
}

export interface DataScreenCategory {
  categoryId?: number | null
  categoryCode?: string
  categoryName?: string
  salesAmount?: number
  percentage?: number
}

export interface DataScreenTransaction {
  orderId?: string
  storeId?: number
  storeName?: string
  orderNo?: string
  productDetails?: string
  quantity?: number
  amount?: number
  orderTime?: string
}

export interface DataScreenLatestTransactionsParams extends DataScreenOverviewParams {
  storeId?: number
  limit?: number
}

export interface DataScreenStoreLocation {
  storeId?: number
  storeName?: string
  longitude?: string | null
  latitude?: string | null
}

export interface DataScreenCityDistribution {
  cityName?: string
  storeCount?: number
  stores?: DataScreenStoreLocation[]
}

export interface DataScreenDistribution {
  storeCount?: number
  directStoreCount?: number
  jointStoreCount?: number
  cities?: DataScreenCityDistribution[]
}

export interface DataScreenStoreEfficiency {
  storeId?: number
  storeName?: string
  qualityName?: string
  salesAmount?: number
  area?: number
  employeeCount?: number
  floorEfficiency?: number
  laborEfficiency?: number
}

export interface DataScreenStoreEfficiencyParams extends DataScreenOverviewParams {
  isPage?: boolean
  pageNum?: number
  pageSize?: number
  orderByColumn?: string
  isAsc?: 'asc' | 'desc'
  reasonable?: boolean
}

export interface DataScreenStoreEfficiencyPage {
  rows?: DataScreenStoreEfficiency[]
  code?: number
  msg?: string
  total?: number
  pageNum?: number
  pageSize?: number
  totalPage?: number
}

export interface TrendPoint {
  date: string
  value: number
}

export const screenApi = {
  getOverview(params: DataScreenOverviewParams) {
    return http.post<DataScreenOverview>('/miss-statistics/dataScreen/overview', params)
  },

  getRankings(params: DataScreenRankingsParams) {
    return http.post<DataScreenRankings>('/miss-statistics/dataScreen/rankings', params)
  },

  getCategoryShare(params: DataScreenOverviewParams) {
    return http.post<DataScreenCategory[]>('/miss-statistics/dataScreen/categoryShare', params)
  },

  getLatestTransactions(params: DataScreenLatestTransactionsParams) {
    return http.post<DataScreenTransaction[]>('/miss-statistics/dataScreen/latestTransactions', params)
  },

  getDistribution() {
    return http.post<DataScreenDistribution>('/miss-statistics/dataScreen/distribution')
  },

  getStoreEfficiency(params: DataScreenStoreEfficiencyParams) {
    return http.post<DataScreenStoreEfficiencyPage>('/miss-statistics/dataScreen/storeEfficiency', params)
  },

  getTrend(params?: { startDate?: string; endDate?: string }) {
    return http.get<TrendPoint[]>('/screen/trend', { params })
  },
}
